var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 37.435,
    height: 26.015,
    viewBox: "0 0 37.435 26.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_31881",
    x: 0,
    y: 0,
    width: 37.435,
    height: 26.015,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LU-Flag",
    transform: "translate(1.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1.5, -0.5)",
    filter: "url(#Rectangle_31881)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31881-2",
    "data-name": "Rectangle 31881",
    width: 34.435,
    height: 23.015,
    transform: "translate(1.5 0.5)",
    fill: "#0aaae6"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31882",
    "data-name": "Rectangle 31882",
    width: 34.435,
    height: 8.095,
    transform: "translate(0 7.459)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31883",
    "data-name": "Rectangle 31883",
    width: 34.435,
    height: 7.459,
    fill: "#e63232"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuFlag);
export default __webpack_public_path__ + "static/media/LU-Flag.29f6bf7fe89661fb893789260ffa58ee.svg";
export { ForwardRef as ReactComponent };